import { ArrowLeftOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Checkbox, Form, Input, Layout, Select, Skeleton } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "../../../../Hooks/useAuth";
import { FinancialLinesService } from "../../../services/financialLines";
import CardTitleCustom from "../../../components/card/title";
import { AllStates } from "../../../../Utils/AllStates";
import { AllSubventionsDeadlines } from "../../../../Utils/AllSubventionsDeadlines";
import { useToast } from "../../../../antd/hooks/toast";
//import FinancialOpeningsTab from "../../../../Pages/RegistrationDocumentsFinep/FinancialOpeningsTab";

export interface IFormItemsSubvention {
    banco: any;
    titulo_da_linha: any;
    abrangencia: any;
    objetivo: any;
    contrapartida: any;
    prazos: any;
    valores: any;
    tipo_de_beneficiario: any;
    link_saiba_mais: any;
    ativar_linha: any;
    email_usuario: any;
}

export interface IFormItemsSubventionPut {
    id: string;
   userEmail: string;
    goal: string;
    value: string;
    counterpart: string;
    typeOfBeneficiary: string;
    deadlines: string;
    bankName: string;
    title: string;
    linkLearnMore: string;
    isVisible: string | boolean;
    coverage: string;
}

export default function RegisterSubvention() {
    const toast = useToast();
    const [form] = Form.useForm();
    const { state } = useLocation();
    const authData = useAuth();
    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(false);
    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

    const getSubvention = async () => {
        try {
            setLoading(true);
            const { data } = await FinancialLinesService.getSubvetion(state.id);
            const { financingLines } = data;
            var coverage = financingLines.coverage.split(",");
            const deadlineItem = AllSubventionsDeadlines.find(
                (item) => item.value === Number(data.deadlines)
            ) || { label: "", value: "" };

            form.setFields([
                { name: "banco", value: financingLines.bankName },
                { name: "titulo_da_linha", value: financingLines.title },
                { name: "abrangencia", value: coverage },
                { name: "objetivo", value: data.goal },
                { name: "contrapartida", value: data.counterpart },
                { name: "prazos", value: deadlineItem.value },
                { name: "valores", value: data.value },
                { name: "tipo_de_beneficiario", value: data.typeOfBeneficiary },
                { name: "link_saiba_mais", value: financingLines.linkLearnMore },
                { name: "ativar_linha", value: financingLines.isVisible },
            ]);
        } catch (err) {
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (value: any) => {
        if (value.includes("AllStates")) {
            value.splice(0, value.length - 1);
        }
    };

    const handleSubmit = async (values: IFormItemsSubvention) => {
        debugger;
        let coverage = "";
        if (Array.isArray(values.abrangencia)) {
            values.abrangencia.forEach((cover, index) => {
                if (index != values.abrangencia.length - 1) {
                    coverage += cover + ",";
                } else {
                    coverage += cover;
                }
            });
        } else {
            coverage = values.abrangencia;
        }
        setLoadingSubmit(true);

        if (state) {
            // CASO ATUALIZE
            try {
                var result = await FinancialLinesService.putSubvention({
                    bankName: values.banco,
                    counterpart: values.contrapartida,
                    coverage: coverage,
                    deadlines: values.prazos,
                    goal: values.objetivo,
                    id: state.id,
                    isVisible: values.ativar_linha,
                    linkLearnMore: values.link_saiba_mais,
                    title: values.titulo_da_linha,
                    typeOfBeneficiary: values.tipo_de_beneficiario,
                    userEmail: authData.userEmail,
                    value: values.valores,
                });
                if (result.status == 200) {
                    navigate("/finance/financialLines");
                    toast.success({ message: "Linha de financiamento editada!" });
                } else {
                    toast.error({ message: "Erro ao editar linha de financiamento" });
                    if (result.errors.length != 0) {
                        result.errors.forEach((error: string) =>
                            toast.error({ message: error })
                        );
                    }
                }
            } catch (err) {
                toast.error({ message: "Erro interno" });
            }
        } else {
            // CASO CRIE NOVO
            try {
                const data: IFormItemsSubvention = {
                    ...values,
                    email_usuario: authData.userEmail,
                };
                data.abrangencia = coverage;

                var result = await FinancialLinesService.postSubvetion(data);
                if (result.statusCode == 200) {
                    navigate("/finance/financialLines");
                    toast.success({ message: "Linha de financiamento cadastrada!" });
                } else {
                    toast.error({ message: "Erro ao cadastrar linha de financiamento" });
                    if (result.errors.length != 0) {
                        result.errors.forEach((error: string) =>
                            toast.error({ message: error })
                        );
                    }
                }
            } catch (err) {
                toast.error({ message: "Erro interno" });
            }
        }
        setLoadingSubmit(false);
    };
    const redirect = () => {
        navigate(`/finance/financialLines`)
    }


    useEffect(() => {
        // CASO ENTRE COM UM JÁ CADASTRADO PARA EDITAR
        if (state) {
            getSubvention();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ) => (
        <>
            {label}
            {required && <span style={{ color: "red" }}>*</span>}
        </>
    );

    return (
        <Layout
            style={{
                background: "white",
                padding: "30px",
                marginTop: "16px",
                borderRadius: "15px",
            }}
        >
            <div>
                <Button
                onClick={() => redirect()}
                    style={{
                        width: "7%",
                        height: "40px",
                        backgroundColor: "white",
                        color: "#0000A4",
                        marginBottom: '20px',
                        border: '2px solid #0000A4'
                    }}
                >
                    <ArrowLeftOutlined />
                    Voltar
                </Button>
            </div>
            {CardTitleCustom({
                text: `${state ? "Editor" : "Cadastro"} de Subvenção`,
            })}

            <div>
                {loading ? (
                    <Skeleton active style={{ margin: "25px 0px 0px 0px" }} />
                ) : (
                    <Form
                        layout="vertical"
                        requiredMark={customizeRequiredMark}
                        form={form}
                        onFinish={handleSubmit}
                        onSubmitCapture={(e) => e.preventDefault()}
                    >
                        <div
                            style={{
                                display: "grid",
                                gridTemplate: '"a b c" auto / 1fr 1fr 1fr',
                                columnGap: "16px",
                                margin: "16px 0px 0px 0px",
                            }}
                        >
                            <Form.Item
                                label="Banco"
                                name="banco"
                                rules={[
                                    {
                                        required: true,
                                        message: "Por favor, insira seu banco de uso!",
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="Título da Linha"
                                name="titulo_da_linha"
                                rules={[
                                    {
                                        required: true,
                                        message: "Por favor, insira o dono do título da linha!",
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="Abrangência"
                                name="abrangencia"
                                rules={[
                                    {
                                        required: true,
                                        message: "Por favor, insira sua abrangência!",
                                    },
                                ]}
                            >
                                <Select
                                    mode="multiple"
                                    style={{ width: "100%" }}
                                    placeholder="Please select"
                                    defaultValue={[]}
                                    options={AllStates}
                                    onChange={handleChange}
                                />
                            </Form.Item>
                        </div>

                        <div
                            style={{
                                display: "grid",
                                gridTemplate: '"a b" auto / 1fr 1fr',
                                columnGap: "16px",
                                margin: "0px 0px 16px 0px",
                            }}
                        >
                            <div>
                                <Form.Item
                                    label="Objetivo"
                                    name="objetivo"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Por favor, insira o objetivo!",
                                        },
                                    ]}
                                >
                                    <Input.TextArea />
                                </Form.Item>
                                <Form.Item
                                    label="Contrapartida"
                                    name="contrapartida"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Por favor, insira a contrapartida!",
                                        },
                                    ]}
                                >
                                    <Input.TextArea />
                                </Form.Item>
                                <Form.Item
                                    label="Prazos"
                                    name="prazos"
                                    rules={[
                                        { required: true, message: "Por favor, insira os prazos!" },
                                    ]}
                                >
                                    <Select options={AllSubventionsDeadlines}></Select>
                                </Form.Item>
                            </div>

                            <div>
                                <Form.Item
                                    label="Valores"
                                    name="valores"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Por favor, insira os valores!",
                                        },
                                    ]}
                                >
                                    <Input.TextArea />
                                </Form.Item>
                                <Form.Item
                                    label="Tipo de beneficiário"
                                    name="tipo_de_beneficiario"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Por favor, insira o beneficiário!",
                                        },
                                    ]}
                                >
                                    <Input.TextArea />
                                </Form.Item>
                                <Form.Item
                                    label="Link para o ”Saiba mais”:"
                                    name="link_saiba_mais"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                "Por favor, insira o link para saber mais do seu projeto!",
                                        },
                                    ]}
                                >
                                    <Input.TextArea />
                                </Form.Item>
                            </div>
                        </div>

                        <div style={{ width: "100%" }}>
                            <Form.Item
                                label="Ativar linha"
                                name="ativar_linha"
                                layout="horizontal"
                                valuePropName="checked"
                            >
                                <Checkbox />
                            </Form.Item>
                        </div>

                        <Button
                            htmlType="submit"
                            loading={loadingSubmit}
                            style={{
                                width: "100%",
                                height: "40px",
                                backgroundColor: "#0000A4",
                                color: "white",
                            }}
                        >
                            {state ? (
                                <>Atualizar linha</>
                            ) : (
                                <>
                                    <PlusCircleOutlined />
                                    &nbsp;Adicionar Linha
                                </>
                            )}
                        </Button>
                    </Form>
                )}
            </div>
        </Layout>
    );
}
